import { useIntl } from 'react-intl';

import { schoolsLogos } from '@/components/schools/Hero/data';
import { SupportedSchoolLanguage } from '@/components/schoolsResources/Guides/types';
import { useLocale } from '@/hooks/locale/useLocale';

import messages from './messages';
import { Background, BodyText, Content, Grid, Heading, Logo, Wrapper } from './styles';

const Hero = () => {
	const { formatMessage } = useIntl();
	const { calmLanguage } = useLocale();
	const logo = schoolsLogos[calmLanguage as SupportedSchoolLanguage] || schoolsLogos.en;
	return (
		<Wrapper>
			<Background src="/_n/images/schools/resources-hero.webp" />
			<Grid>
				<Content>
					<Logo as={logo} />
					<Heading>{formatMessage(messages.heading)}</Heading>
					<BodyText>{formatMessage(messages.bodyText)}</BodyText>
				</Content>
			</Grid>
		</Wrapper>
	);
};

export default Hero;
